import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const heartPulseClass = css`
  @keyframes heartPulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }

  svg {
    animation: heartPulse 350ms ease forwards;
  }
`;

export const StyledPulsatingHeart = styled.div`
  display: flex;
  align-items: center;
  padding-right: 1.13rem;
  padding-left: 0.125rem;
`;
